import { deleteLineItem } from "@lib/data/cart"
import { Spinner, Trash } from "@medusajs/icons"
import { clx } from "@modules/common/components/ui"
import { useState } from "react"

const DeleteButton = ({
  id,
  children,
  className,
  "aria-label": ariaLabel,
}: {
  id: string
  children?: React.ReactNode
  className?: string
  "aria-label"?: string
}) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async (id: string) => {
    setIsDeleting(true)
    await deleteLineItem(id).catch((_err) => {
      setIsDeleting(false)
    })
  }

  return (
    <div
      className={clx(
        "flex items-center justify-between text-small-regular",
        className
      )}
    >
      <button
        className="flex gap-x-1 text-ui-fg-subtle hover:text-ui-fg-base cursor-pointer"
        onClick={() => handleDelete(id)}
        aria-label={ariaLabel ?? (children ? undefined : "Remove item from cart")}
      >
        {isDeleting ? (
          <Spinner className="animate-spin" aria-hidden="true" />
        ) : (
          <Trash aria-hidden="true" />
        )}
        <span>{children}</span>
      </button>
    </div>
  )
}

export default DeleteButton
